@use "~theme/typography";
@use "~theme/breakpoints";
@use "~components/LegacyCard/tokens.scss" as Card;

.card {
  display: flex;

  @include breakpoints.desktop {
    margin-top: auto;
    margin-bottom: auto;
    display: block;
    max-width: Card.$max-width;
  }
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.header {
  @include typography.heading3;

  @include breakpoints.desktop {
    margin-top: 0;
    margin-bottom: 16px;
  }
}

.fieldsContainer {
  @include breakpoints.desktop {
    padding-left: 12px;
  }
}

.hasDivider {
  border-bottom: solid 1px var(--blue-01-at-30);
  padding-bottom: 20px;
  margin-bottom: 20px;

  @include breakpoints.desktop {
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
}

.address {
  font-style: normal;
}

.container {
  padding: {
    left: var(--mobile-gutter);
    right: var(--mobile-gutter);
    bottom: 20px;
  }
  display: flex;
  flex-direction: column;
  flex: 1;

  @include breakpoints.desktop {
    padding-top: 20px;
  }
}

.personalDetails {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px 30px;

  @include breakpoints.desktop {
    margin-bottom: 40px;
  }

  > :first-child {
    grid-column: span 2;

    @include breakpoints.desktop {
      grid-column: 1;
      margin-bottom: 0;
    }
  }

  > :nth-child(3) {
    margin-left: 12px;

    @include breakpoints.desktop {
      margin-left: 0;
    }
  }

  > :nth-child(4) {
    grid-column: span 2;

    @include breakpoints.desktop {
      grid-column: auto;
    }
  }
}

.medicaid{
  background-color: aliceblue;
  padding: 5px;
  margin-top: 10px;
  @include breakpoints.desktop {
    margin-top: 0px;
  }
}

.navOptions {
  display: flex;
  margin-top: 16px;

  // flex-wrap: wrap;
  // flex-direction: column;
  flex-flow: column wrap;

  @include breakpoints.desktop {
    flex-direction: row-reverse; // Put the first button on the right when it's a 2-up layout.
  }
}

.button {
  flex: 1;
  margin: 8px 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @include breakpoints.desktop {
    margin: 0 8px;

    &:first-child {
      margin-right: 0;
    }

    &:last-child {
      margin-left: 0;
    }
  }
}

.modal {
  max-width: 518px;
}
